export const isXmlString = (arg: unknown): arg is string => {
  if (typeof arg !== "string") {
    return false;
  }

  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(arg, "application/xml");

  // Check if parsing the string results in a parsing error
  return !xmlDoc.getElementsByTagName("parsererror").length;
};
